import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50405e90"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Excelファイルは以下のフォーマットに従って作成してください。")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" カテゴリIDは")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("こちら")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("から確認してください。 ")

import { ref, Ref, onMounted } from 'vue'
  import CategoryList from '@/components/project_import/CategoryList.vue'
  import { QuestionCategory } from '@/types/question_category'
  import { QuestionCategoryRepository } from '@/repositories/QuestionCategoryRepository'

  interface Props {
    project_id: number,
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    project_id: { type: Number, required: true }
  },
  setup(__props: any) {

const props = __props as {
    project_id: number,
  }
  

  const categories: Ref<QuestionCategory[]> = ref<QuestionCategory[]>([]);
  onMounted(async () => {
    const repository = new QuestionCategoryRepository(props.project_id);
    categories.value = await repository.getList();
  });

  const visible: Ref<boolean> = ref<boolean>(false);

  const data = [
    {
      item1: '1列目: 質問',
      item2: '2列目: 解答',
      item3: '3列目: カテゴリID',
    },
  ];

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_el_button, {
        type: "text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = !visible.value))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _createVNode(_component_el_table, {
      data: data,
      border: "",
      "show-header": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { prop: "item1" }),
        _createVNode(_component_el_table_column, { prop: "item2" }),
        _createVNode(_component_el_table_column, { prop: "item3" })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "カテゴリ一覧"
    }, {
      default: _withCtx(() => [
        _createVNode(CategoryList, { categories: categories.value }, null, 8, ["categories"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})